module.exports = __webpack_public_path__ + "static/media/0331_Small.53fb9dbe.jpg";